import { render } from "./InductionCard.vue?vue&type=template&id=b93573a0&scoped=true"
import script from "./InductionCard.vue?vue&type=script&lang=js"
export * from "./InductionCard.vue?vue&type=script&lang=js"

import "./InductionCard.vue?vue&type=style&index=0&id=b93573a0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b93573a0"]])

export default __exports__